
export enum DashboardRequestStatus {
  Success = 0,
  Failed = 1,
  Reloaded = 2
}
